import React from 'react';
import { Link } from 'react-router-dom';

const CustomPageLink = props => (
  <Link to={`/p/${props.url}`} className={props.class}>{props.title}</Link>
);

export default CustomPageLink;
